var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "custom-class": "yearDialog",
        visible: _vm.dialogTableVisible,
        width: "500px",
        "show-close": false,
        "append-to-body": "",
        "before-close": _vm.handleDialogClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogTableVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "bigTitle" }, [_vm._v("岗位描述")]),
      _c("div", { domProps: { innerHTML: _vm._s(_vm.jobReqTxt) } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }